class LoginConfig {
    public static validationMessages = {
        userRequired: "Por favor ingrese su identificación.",
        passwordRequired: "Por favor ingrese su password.",
        wrongUserOrEmail: "Identificacion y password no concuerdan!."
    };
}

export { LoginConfig };